import axios from 'axios';
import config from '../config/config';
import { UsuarioLogadoGet } from '../utils/usuarioEstaLogado';


//const baseUrl = 'http://192.168.100.44:8080'; // Defina a base URL da sua API
const baseUrl = `${config.API_URL}`

// Crie uma instância do Axios com configurações personalizadas
const axiosInstance = axios.create({
    baseURL: baseUrl,
    headers: {
        'Content-Type': 'application/json', // Tipo de conteúdo padrão
    },
});

// Interceptor para adicionar token de autenticação
axiosInstance.interceptors.request.use(
    (config) => {
        const token = UsuarioLogadoGet();
        if (token.token) {
            config.headers.Authorization = `Bearer ${token.token}`;
        }
        if (token.usuario) {
            config.headers['User'] = `${token.usuario}`;
        }

        if (token.ip) {
            config.headers["IP"] = `${token.ip}`;
        }

        config.headers["Setor"] = `${token.setorId}`;

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default axiosInstance;
